








































import { Vue, Component, Prop } from "vue-property-decorator";
import { DeviceModel, ReportModel } from "@/store/types";
import { rangedLatestStatus, dayStr, displayingTimeSpan } from '@/helper/deviceStatus';

@Component
export default class DevicesStatus extends Vue {
  @Prop({ required: true, default: [] as DeviceModel[] })
  private devices!: DeviceModel[];

  private rangedLatestLog(device: DeviceModel, time: Date) {
    return rangedLatestStatus(device, time);
  }

  private dayStr(date: Date): string {
    return dayStr(date);
  }

  private displayingTimeSpan(date: Date) {
    return displayingTimeSpan(date);
  }

  private deleteDevice(deviceId: string) {
    this.$emit('delete-device', deviceId);
  }

  private installSDK(deviceId: string) {
    this.$emit('install-sdk', deviceId);
  }

  private showDeviceDetails(deviceId: string) {
    this.$emit('device-detail', deviceId);
  }
}
